import React, { useEffect, useState } from "react";

import { FaChevronDown, FaChevronUp } from "react-icons/fa6";

import "./styles.scss";

const PromptInput = ({ model, updateValue }) => {

    const [promptValue, setPromptValue] = useState(model?.systemPrompt)

    const handleChangePrompt = (e) => {
        const newValue = e.target.value;
        setPromptValue(newValue);

        updateValue(model?.title, newValue);
    }

    return (
        <div className="prompt-input-container input-wrapper">
            <div className="input-label">{model?.title}</div>
            <textarea
                className="input-textarea"
                value={promptValue}
                onChange={handleChangePrompt}
                placeholder={`Enter ${model?.title}`}
            />
        </div>
    )
}

const SystemPrompts = ({ setSystemPrompts, modelsList }) => {
    const [modelDetails, setModelDetails] = useState([])
    const [showContents, setShowContents] = useState(true)

    const handleShowContent = () => {
        setShowContents(!showContents)
    }

    const updateModelValue = (key, value) => {
        const updatedModels = modelDetails.map((item) =>
            item?.title === key ? { ...item, value } : item
        );

        setModelDetails(updatedModels);
        setSystemPrompts(updatedModels);
    };

    useEffect(() => {
        setModelDetails(modelsList)
    }, [modelsList])

    return (
        <div className="system-prompts-container">
            <div className="container-title-section" onClick={() => handleShowContent()}>
                <div className="title-main">System Prompts</div>
                <div className="title-icons">{showContents ? <FaChevronDown /> : <FaChevronUp />}</div>
            </div>

            {showContents && (
                <div className="system-prompt-contents">
                    {modelDetails?.map((model) => {
                        return (
                            <PromptInput key={model?.title} model={model} updateValue={updateModelValue} />
                        )
                    })}

                    {(modelDetails?.length === 0) && (
                        <div className="no-content-section">
                            Please select models!
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}

export default SystemPrompts